export const loyaltyLion = () => {
  const $loyaltyLion = document.querySelector(".shopify-section.loyaltylion");

  if ($loyaltyLion) {
    const process = () => {
      const lionElEarnedPoints = $loyaltyLion.querySelector(
        '[data-lion-points="approved"]'
      );
      const originEarnedPoints = $loyaltyLion.querySelector(
        '[data-ref="earnedPoints"]'
      );

      const lionElPendingPoints = $loyaltyLion.querySelector(
        '[data-lion-points="pending"]'
      );

      const originPendingPoints = $loyaltyLion.querySelector(
        '[data-ref="pendingPoints"]'
      );

      if (lionElEarnedPoints && originEarnedPoints) {
        originEarnedPoints.textContent = `You have ${lionElEarnedPoints.textContent} points.`;
      }

      if (lionElPendingPoints && originPendingPoints) {
        originPendingPoints.textContent = `(${lionElPendingPoints.textContent} pending)`;
      }
    };

    const target = document.querySelector("[data-lion-points]");
    const config = { childList: true, attributes: true };

    const observer = new MutationObserver(() => {
      process();
    });

    observer.observe(target, config);
    process();
  }
};

export default loyaltyLion;
